export const DEVICES = "DEVICES";
export const EVENTS = "EVENTS";
export const TRIPS = "TRIPS";
export const IMAGES = "IMAGES";
export const VIDEOS = "VIDEOS";
export const BASE_URL = "FILE_BASE_URL";
